import { gql } from '__generated__';

export default gql(`
  mutation EditMailPreferences($input: EditMailPreferencesInput!) {
    editMailPreferences(input: $input) {
      id
      email
      available_mail_permissions {
        id
        title
      }
      granted_mail_permissions {
        id
      }
    }
  }
`);
